import { Bookmark } from "common/assets/icons";
import { styled, yellow } from "common/components";

export const StyledBookmarkIcon = styled(Bookmark)(({ theme }) => ({
  fill: yellow[700],
}));
